import { render, staticRenderFns } from "./copyInspectionStandardList.vue?vue&type=template&id=4628907a&"
import script from "./copyInspectionStandardList.vue?vue&type=script&lang=js&"
export * from "./copyInspectionStandardList.vue?vue&type=script&lang=js&"
import style0 from "./copyInspectionStandardList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports